<div
  class="mat-elevation-z2 addon-package-card"
  (click)="emitClicked()"
  inViewOnlyOnce>
  <header class="package-image">
    <apex-file-usage-preview
      self="addon-package"
      [selfId]="package.id"
      name="gallery"
      [title]="'Gallery' | translate">
    </apex-file-usage-preview>
    <div class="image-overlay">
      <button
        class="view-gallery-button"
        mat-icon-button
        *ngIf="package?.gallery?.length"
        (click)="$event.stopPropagation(); openFileUsages()"
        [matTooltip]="'View gallery' | translate">
        <mat-icon>photo_library</mat-icon>
      </button>
    </div>
  </header>
  <main class="package-content">
    <div class="package-title mat-h3">
      {{ package?.title }}
    </div>
    <div class="package-description mat-body-2 line-clamp-3">
      {{ package?.description }}
    </div>
    <div class="package-price">
      <div class="mat-caption">
        <T str="Price"></T>
      </div>
      <div class="mat-h4">
        {{ packagePrice | apexCurrency: 'NOK' : '' }}
      </div>
    </div>
  </main>
  <footer class="package-footer">
    <button
      mat-stroked-button
      color="primary"
      (click)="$event.stopPropagation(); emitClicked()">
      <T str="View details"></T>
    </button>
  </footer>
</div>
